import React from 'react';
import Widget from './Widget';
import TrendLine from './d3/TrendLine';
import TrendLineChart from './d3/TrendLineChart';

const TrendLineWrapper = ({ data, periods, type }) => (
    <Widget title="Trend Line" className="trend-line-widget">
        {type === 'Variations' ? (
            <TrendLineChart data={data} periods={periods} />
        ) : (
            <TrendLine data={data} />
        )}
    </Widget>
);

export default TrendLineWrapper;
